import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="protocols--kit-registration-config"
export default class extends Controller {
  static targets = ["globalLevel", "visitLevel", "timepointSelect"];

  applyAll() {
    const level = this.globalLevelTarget.value;
    this.timepointSelectTargets.forEach((select) => (select.value = level));
  }

  applyToVisit(event) {
    const visitId = event.currentTarget.dataset.visitId;
    const visitSelect = this.visitLevelTargets.find(
      (s) => s.dataset.visitId === visitId
    );
    if (!visitSelect) return;
    const level = visitSelect.value;
    this.timepointSelectTargets
      .filter((s) => s.dataset.visitId === visitId)
      .forEach((select) => (select.value = level));
  }
}
